import React from 'react';

import PropTypes from 'prop-types';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

const CustomerCasesCard = (props) => {
  const { content, index } = props;

  return (
    <div className="customer-cases-card-wrapper">
      <ReactCompareSlider
        itemOne={<ReactCompareSliderImage src={content.beforeImage} alt="Before condition" data-gumlet="false" />}
        itemTwo={<ReactCompareSliderImage src={content.afterImage} alt="After condition" data-gumlet="false" />}
        position={50}
      />
      <div className="card-content-one">
        <span
          data-key={`referral::customer_cases_section::cards::card${index + 1}::aligner_name`}
          data-lokalise=""
        >
          {content.aligner}
        </span>
        {content.price && <span>&nbsp;|&nbsp;</span>}
        <span
          data-key={`referral::customer_cases_section::cards::card${index + 1}::price`}
          data-lokalise=""
        >
          {content.price}
        </span>
      </div>
      <div className="card-content-two">
        <span
          data-key={`referral::customer_cases_section::cards::card${index + 1}::aligner_sets`}
          data-lokalise=""
        >
          {content.sets}
        </span>
        <span>&nbsp;|&nbsp;</span>
        <span
          data-key={`referral::customer_cases_section::cards::card${index + 1}::clinic_visits`}
          data-lokalise=""
        >
          {content.visits}
        </span>
        <span>&nbsp;|&nbsp;</span>
        <span
          data-key={`referral::customer_cases_section::cards::card${index + 1}::duration`}
          data-lokalise=""
        >
          {content.duration}
        </span>
      </div>
    </div>
  );
};

export default CustomerCasesCard;

CustomerCasesCard.propTypes = {
  content: PropTypes.shape({
    aligner: PropTypes.string,
    price: PropTypes.string,
    sets: PropTypes.string,
    visits: PropTypes.string,
    duration: PropTypes.string,
    beforeImage: PropTypes.string,
    afterImage: PropTypes.string
  }).isRequired,
  index: PropTypes.number.isRequired
};
